import { isNativePlatform } from "@lib/platform";
import { openUrl, shouldOpenInApp } from "@lib/platform/open-url";

let installed = false;

function handleAnchorClick(event: MouseEvent): void {
  if (event.defaultPrevented) return;
  if (event.button !== 0) return;
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

  const anchor = (event.target as Element | null)?.closest("a[href]");
  if (!anchor || !(anchor instanceof HTMLAnchorElement)) return;

  const href = anchor.getAttribute("href");
  if (!href || href.startsWith("#") || href.startsWith("javascript:")) return;
  if (!shouldOpenInApp(href)) return;

  event.preventDefault();
  openUrl(href);
}

/** Keep http(s) navigation inside the Capacitor WebView (PWA-like behavior). */
export function initNativeLinkHandler(): () => void {
  if (!isNativePlatform() || installed || typeof document === "undefined") {
    return () => undefined;
  }

  installed = true;
  document.addEventListener("click", handleAnchorClick, true);

  const nativeOpen = window.open.bind(window);
  window.open = ((url?: string | URL, target?: string, features?: string) => {
    if (url != null && typeof url !== "undefined") {
      const href = String(url);
      if (shouldOpenInApp(href)) {
        openUrl(href);
        return null;
      }
    }
    return nativeOpen(url, target, features);
  }) as typeof window.open;

  return () => {
    document.removeEventListener("click", handleAnchorClick, true);
    window.open = nativeOpen;
    installed = false;
  };
}
